"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINPlanOption = exports.PINPlanInput = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var react_1 = require("@iconify/react");
var PINInput_1 = require("./PINInput");
var PINPlanOption = function (_a) {
    var key = _a.key;
    return (React.createElement("span", { key: key, style: { display: "none" } }));
};
exports.PINPlanOption = PINPlanOption;
PINPlanOption.displayName = "PINPlanOption";
PINPlanOption.propTypes = {
    title: PropTypes.string,
    value: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    currency: PropTypes.string,
    unit: PropTypes.string,
    description: PropTypes.string,
    infoButton: PropTypes.element,
    disabledDisclosure: PropTypes.string
};
var PINPlanInput = /** @class */ (function (_super) {
    __extends(PINPlanInput, _super);
    function PINPlanInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            options: [],
            error: null,
            value: null
        };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'children' implicitly has an 'any' type.
        _this.retreiveOptions = function (children, fallback) { return children ? React.Children.map(children, function (child) {
            var _a = child.props, title = _a.title, value = _a.value, price = _a.price, currency = _a.currency, unit = _a.unit, description = _a.description, infoButton = _a.infoButton, disabledDisclosure = _a.disabledDisclosure;
            if (child.type.displayName === "PINPlanOption" && Boolean(price) && Boolean(value)) {
                return {
                    title: title || value,
                    value: value,
                    currency: currency,
                    price: price,
                    unit: unit,
                    description: description,
                    infoButton: infoButton,
                    disabledDisclosure: disabledDisclosure
                };
            }
            return null;
            // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'item' implicitly has an 'any' type.
        }).filter(function (item) { return (item !== null); }) : fallback || []; };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter '_' implicitly has an 'any' type.
        _this.getValueOnChange = function (_, complement) {
            // @ts-expect-error ts-migrate(2461) FIXME: Type 'null' is not an array type.
            var value = __spreadArrays(_this.state.value);
            // Add or remove the elem
            var indexOfValue = value.indexOf(complement);
            if (indexOfValue >= 0) {
                value.splice(indexOfValue, 1);
            }
            else {
                value.push(complement);
            }
            _this.setState({ value: value });
            return value;
        };
        return _this;
    }
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
    PINPlanInput.prototype.componentWillReceiveProps = function (props) {
        var _this = this;
        this.setState(function () { return ({
            options: _this.retreiveOptions(props.children, props.plans),
            value: props.value || _this.state.value || props.defaultValue || []
        }); });
    };
    PINPlanInput.prototype.componentDidMount = function () {
        var _this = this;
        this.setState(function () { return ({
            options: _this.retreiveOptions(_this.props.children, _this.props.plans)
        }); });
        if (!this.props.onChangeForm) {
            return;
        }
        /* Inform the form of the input initial value and validity */
        var error = this.getError(this.state.value);
        if (this.props.showInitialError) {
            this.setState(function () { return ({ error: error }); });
        }
        this.props.onChangeForm(this.props.name, this.state.value || this.props.value || this.props.defaultValue, this.props.defaultValue, error);
    };
    // @ts-expect-error ts-migrate(2416) FIXME: Property 'render' in type 'PINPlanInput' is not as... Remove this comment to see the full error message
    PINPlanInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, required = _a.required, hiddenRequired = _a.hiddenRequired;
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'v' implicitly has an 'any' type.
        var t = this.props.t || (function (v) { return (v); });
        return (React.createElement("div", { className: "pinplaninput " + (this.props.className ? this.props.className : "") },
            React.createElement("div", { className: "pinplaninput-label" },
                (required && !hiddenRequired) && "* ",
                this.props.label || ""),
            this.state.options.map(function (option, index) { return (
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'label' does not exist on type 'never'.
            React.createElement("div", { key: "pinplaninput" + index + option.label + option.value, className: "pinplaninput-option" + (
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'disabledDisclosure' does not exist on ty... Remove this comment to see the full error message
                option.disabledDisclosure ? " disabled" : ""), 
                // @ts-expect-error ts-migrate(2322) FIXME: Type '(() => void) | null' is not assignable to ty... Remove this comment to see the full error message
                onClick: 
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'disabledDisclosure' does not exist on ty... Remove this comment to see the full error message
                !option.disabledDisclosure ? function () { _this.onChange(null, option.value); } : null },
                React.createElement("div", { className: "pinplaninput-option-data" },
                    React.createElement("div", { className: "pinplaninput-option-data-topline" },
                        React.createElement("div", { className: "pinplaninput-option-data-topline-title" }, option.title),
                        React.createElement("div", { className: "pinplaninput-option-data-topline-price" },
                            t("form.plan.startAt"),
                            React.createElement("span", null, option.price),
                            option.unit)),
                    React.createElement("div", { className: "pinplaninput-option-data-description" }, option.description),
                    option.infoButton),
                option.disabledDisclosure
                    ? React.createElement("div", { className: "pinplaninput-option-disabled-disclosure" }, option.disabledDisclosure)
                    : React.createElement("div", { className: "pinplaninput-option-checkmark" + (
                        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                        _this.state.value.indexOf(option.value) < 0 ? "" : " selected") },
                        React.createElement(react_1.Icon, { icon: "mdi:check", style: { fontSize: "2rem" }, color: "white" })))); })));
    };
    PINPlanInput.className = "PINPlanInput";
    PINPlanInput.propTypes = __assign(__assign({}, PINInput_1.PINInput.propTypes), { plans: PropTypes.arrayOf(
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'WeakValidationMap<any> | undefin... Remove this comment to see the full error message
        PropTypes.shape(PINPlanOption.propTypes)) });
    return PINPlanInput;
}(PINInput_1.PINInput));
exports.PINPlanInput = PINPlanInput;
//# sourceMappingURL=PINPlanInput.js.map